export const PUBLICATIONS_PER_PAGE = 12;

export const ORDERBYLIST = [
  { type: '', label: 'newest', value: 'verifiedAt-DESC' },
  { type: 'sell', label: 'chepeasts', value: 'EXWPrice-ASC' },
  { type: 'sell', label: 'moreExpensive', value: 'EXWPrice-DESC' },
  { type: 'rent', label: 'rentChepeasts', value: 'nationalRentPrice-ASC' },
  { type: 'rent', label: 'rentMoreExpensive', value: 'nationalRentPrice-DESC' }
];
